<template>
	<transition name="fade">
	<!-- Start Page Content -->
	<div id="dashboard">
		<div v-if="DashboardText && !isArchives" class="card mt-4">
			<div class="card-header bg-primary details"><h5>Message from Bungalow 7 Clients</h5></div>
			<div class="card-body">
				<div v-html="DashboardText"></div>
			</div>
		</div>
		<div v-if="!OrganizationIDAccess" class="row mt-4">
			<el-select key="orgSelect" v-model="OrganizationIDs" class="oneHundred" placeholder="Clients" @change="getInitialData" multiple default-first-option filterable clearable>
				<el-option
						v-for="item in Organizations"
						:label="item.OrganizationName"
						:value="item.OrganizationID"
						:key="item.OrganizationID">
				</el-option>
			</el-select>
		</div>
		<div class="row mt-4">
			<!-- column -->
			<div class="col-12">
				<div class="card">
					<div class="card-body-no">
						<div class="row">
							<div class="col-6">
								<h4 class="card-title">Welcome {{currentUser.FirstName + ' ' + currentUser.LastName}}</h4>
								<img v-if="organization.Params.ClientLogo" class="client-logo" :src="organization.Params.ClientLogo">
								<p>e-mail: {{currentUser.EmailAddress}}</p>
							</div>
							<div class="col-6">
								<h4 class="card-title">Latest Downloads</h4>
								<span v-if="latest.length == 0" style="font-size: 13px;">No Downloaded Files Yet</span>
								<span v-else style="font-size: 13px;">
									<div v-for="file in latest">
										{{file.ClientFileName}} - {{file.DownLoadDate}}
									</div>
								</span>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row mt-4">
			<!-- column -->
			<div class="col-12">
				<div class="card">
					<div v-loading="loading" class="card-body-no">

						<h4 v-if="isArchives" lass="card-title">Archives</h4>
						<h4 v-else lass="card-title">Latest Files</h4>
						<el-input
								class="search"
								v-model="search"
								size="default"
								clearable
                                style="margin-right: 10px;"
								placeholder="Type to search"/>
						<el-button size="default" type="primary" @click="fileFilter">Search</el-button>
						<br>
						<el-select key="select1" size="default" style="margin-right: 10px;width: 120px;" class="mb-1" v-model="bpm" @change="fileFilter" placeholder="BPM" default-first-option filterable clearable>
							<el-option
									v-for="item in BPMs"
									:key="item.SpecName"
									:label="item.SpecName"
									:value="item.SpecName">
							</el-option>
						</el-select>
						<el-select key="select2" size="default" style="margin-right: 10px;width: 200px;" class="mb-1" v-model="genre" @change="fileFilter" placeholder="Genre" default-first-option filterable clearable>
							<el-option
									v-for="item in Genres"
									:key="item.SpecName"
									:label="item.SpecName"
									:value="item.SpecName">
							</el-option>
						</el-select>
						<el-select key="select3" size="default" style="margin-right: 10px;width: 200px;" class="mb-1" v-model="mood" @change="fileFilter" placeholder="Mood" default-first-option filterable clearable>
							<el-option
									v-for="item in Moods"
									:key="item.SpecName"
									:label="item.SpecName"
									:value="item.SpecName">
							</el-option>
						</el-select>
						<el-select key="select4" size="default" style="margin-right: 10px;width: 150px;" class="mb-1" v-model="format" @change="fileFilter" placeholder="Format" default-first-option filterable clearable>
							<el-option
									v-for="item in Formats"
									:key="item.SpecName"
									:label="item.SpecName"
									:value="item.SpecName">
							</el-option>
						</el-select>
						<el-select key="select5" size="default" style="margin-right: 10px;width: 150px;" class="mb-1" v-model="length" @change="fileFilter" placeholder="Length" default-first-option filterable clearable>
							<el-option
									v-for="item in Lengths"
									:key="item.SpecName"
									:label="item.SpecName"
									:value="item.SpecName">
							</el-option>
						</el-select>
                        <el-button type="primary" style="float:right;margin-top: 50px;margin-bottom: 15px;" @click="bulkFileDownload();" >Download all Selected<i class="el-icon-download el-icon-right"></i></el-button>
                        <el-table class="mt-1"
							  :data="PageFiles"
								border
								key="tablefiles"
								size="small"
								max-height="600"
								empty-text="No Files Available"
                                @sort-change="sortFile"
								striped
								style="width: 100%">
							<el-table-column
									prop="sample"
									label="Sample"
									align="center"
									width="75">
								<template #default="scope">
									<i v-if="scope.row.samplePlaying == 'n'" class="fas fa-play-circle" @click="playSound((scope.row.SampleURL ? scope.row.SampleURL : scope.row.FullURL));scope.row.samplePlaying = 'y';"></i>
									<i v-else class="fas fa-pause-circle" @click="stopSound((scope.row.SampleURL ? scope.row.SampleURL : scope.row.FullURL));scope.row.samplePlaying = 'n';"></i>
								</template>
							</el-table-column>
                            <el-table-column
                                prop="ClientFileName"
                                label="Name"
                                sortable="custom"
                            >
                            </el-table-column>
                            <el-table-column
                                prop="OrganizationNames"
                                label="Client(s)"
                                sortable="custom"
                                width="150"
                            >
                                <template #default="scope">
                                    <div v-html="scope.row.OrganizationNames"></div>
                                </template>
                            </el-table-column>
							<el-table-column
									prop="TimeAgo"
									label="Uploaded"
									width="100"
							>
							</el-table-column>
							<el-table-column
									prop=""
									label="Properies"
							>
								<template #default="scope">
									<div v-if="scope.row.BPM" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">BPM: {{scope.row.BPM}}</div>
									<div v-if="scope.row.Mood" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">Mood: {{scope.row.Mood}}</div>
									<div v-if="scope.row.Length" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">Length: {{scope.row.Length}}</div>
									<div v-if="scope.row.Genre" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">Genre: {{scope.row.Genre}}</div>
									<div v-if="scope.row.Format" style="width: 100%; line-height: 14px;overflow-wrap: break-word;">Format: {{scope.row.Format}}</div>
								</template>
							</el-table-column>
                            <el-table-column
                                prop="Duration"
                                label="Duration"
                                width="110"
                                align="center"
                                sortable="custom"
                            >
                                <template #default="scope">
                                    <span v-html="(!scope.row.Duration || scope.row.Duration == 0 ? '' : scope.row.DurationF)"></span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="Notes"
                                label="Notes"
                                min-width="200"
                            >
                                <template #default="scope">
									<textarea class="el-textarea__inner" v-model="scope.row.FileNotes" @change="changedNotes(scope.row)"></textarea>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="Favorite"
                                label="Favorite"
                                width="110"
                                align="center"
                                sortable
                            >
                                <template #default="scope">
                                    <span v-if="scope.row.Favorite != 'y'" class="Favorite" @click="changedFavorite(scope.row)"><i class="far fa-star"></i></span>
                                    <span v-else class="selectedFavorite" @click="changedFavorite(scope.row)"><i class="fas fa-star"></i></span>
                                </template>
                            </el-table-column>

							<el-table-column
                                v-if="!isHistorical"
                                prop="file"
                                label="Select for Download"
                                width="180"
                                align="center"
							>
								<template #default="scope">
                                    <el-checkbox v-model="scope.row.selected" class="downloadcheckbox"></el-checkbox>
                                    <el-button v-if="scope.row.downloading != 'y'" type="primary" class="downloadbutton" @click="forceFileDownload(scope.row)" >Download<i class="el-icon-download el-icon-right"></i></el-button>
                                    <el-button v-else type="success" class="downloadbutton" :loading="true" >Downloading</el-button>
                                </template>
							</el-table-column>
						</el-table>
						<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								background
								:hide-on-single-page="singlePage"
								class="mt-4"
								:current-page.sync="currentPage"
								:page-sizes="[100, 500, 1000, 2000]"
								:page-size="sizePerPage"
								layout="sizes, prev, pager, next"
								:total="count">
						</el-pagination>
                        <audio ref="audioPlayer" :src="currentFile" autoplay="true" preload="none"
                               v-on:ended="stopSound()"></audio>
					</div>
				</div>
			</div>

			<!-- column -->
		</div>
	</div>
	</transition>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import Util from '../assets/js/util.js';

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
export default {
	name: 'Dashboard',
	data () {
		return {
			loading : false,
            currentStatus : 0,
			currentPage: 1,
			count: 0,
			sizePerPage: 100,
			singlePage : false,
			Files: [],
			FilteredFiles: [],
			PageFiles : [],
			Organizations : [],
			OrganizationIDs : [],
			organization: {Params : []},
			latest: [],
			DashboardText : '',
			audio : '',
			currentFile : '',
			search : '',
			bpm : '',
			genre : '',
			mood : '',
			format :'',
			length : '',
			BPMs : [],
			Genres : [],
			Moods : [],
			Formats : [],
			Lengths: [],
		}
	},
	props:["config"],
	computed: {
		...mapGetters({ currentUser: 'currentUser' }),
		...mapGetters({ componentIDs: 'componentIDs' }),

		createAccess () {
			return Util.createAccess(this.currentUser);
		},
		modifyAccess () {
			return Util.modifyAccess(this.currentUser);
		},
		OrganizationIDAccess () {
			return Util.OrganizationIDAccess(this.currentUser);
		},
        isArchives () {
          return (this.$route.fullPath.indexOf('chives') !== -1 ? true : false);
        },
        isHistorical () {
            return (this.$route.fullPath.indexOf('istorical') !== -1 ? true : false);
        },
        isFavorites () {
            return (this.$route.fullPath.indexOf('avorite') !== -1 ? true : false);
        },

    },
    methods: {
        changedFavorite (row) {
            if (row.Favorite !='y') {
                row.Favorite = 'y';
            } else {
                row.Favorite = 'n';
            }
            this.updateMetadata (row);
        },
        changedNotes (row) {
            this.updateMetadata (row);
        },
	    handleSizeChange(val) {
		    this.sizePerPage = val;
		    this.pageFilter();
	    },
	    handleCurrentChange(val) {
		    this.currentPage = val;
		    this.pageFilter();
	    },
		pageFilter () {
	    	this.PageFiles = [];
	    	let start = (this.currentPage-1) * this.sizePerPage;
			for (let i=0; i < this.FilteredFiles.length; i++) {
				if (i >= start && this.PageFiles.length <= this.sizePerPage) {
					this.PageFiles.push(this.FilteredFiles[i]);
				}
			}
			if (start == 0 && this.PageFiles.length < this.sizePerPage) {
				this.singlePage = true;
			} else {
				this.singlePage = false;
			}
		},
	    fileFilter() {
		    var goodFiles = [];
		    var count = 0;
		    for (let i=0; i < this.Files.length; i++) {
			    var includeFile = true;

			    if (this.search && !this.Files[i].FileName.toLowerCase().includes(this.search.toLowerCase()) && !this.Files[i].ClientFileName.toLowerCase().includes(this.search.toLowerCase())) {
				    includeFile = false;
			    }
			    if (this.bpm && this.bpm != this.Files[i].BPM) {
				    includeFile = false;
			    }
			    if (this.genre && this.genre != this.Files[i].Genre) {
				    includeFile = false;
			    }
			    if (this.mood && this.mood != this.Files[i].Mood) {
				    includeFile = false;
			    }
			    if (this.format && this.format != this.Files[i].Format) {
				    includeFile = false;
			    }
			    if (this.length && this.length != this.Files[i].Length) {
				    includeFile = false;
			    }
			    if (includeFile) {
				    goodFiles.push(this.Files[i]);
			    }
		    }
		    this.FilteredFiles = goodFiles;
		    this.count = this.FilteredFiles.length;
		    this.currentPage = 1;
		    this.pageFilter();
	    },
      sortFile(data) {

        if (data.prop == 'TimeAgo') {
          data.prop = 'TimeAgoSort';
        }
        this.Files.sort(function(a, b) {
            if (data.prop == 'Duration') {
                if (data.order == 'ascending') {
                    var labelA = parseInt(a[data.prop].toString().toLowerCase().trim()),
                        labelB = parseInt(b[data.prop].toString().toLowerCase().trim());
                } else {
                    var labelB = parseInt(a[data.prop].toString().toLowerCase().trim()),
                        labelA = parseInt(b[data.prop].toString().toLowerCase().trim());
                }
                var result = labelA - labelB;

                return result;
            } else {
                if (data.order == 'ascending') {
                    var labelA = a[data.prop].toString().toLowerCase().trim(),
                        labelB = b[data.prop].toString().toLowerCase().trim();
                } else {
                    var labelB = a[data.prop].toString().toLowerCase().trim(),
                        labelA = b[data.prop].toString().toLowerCase().trim();
                }
                if (labelA < labelB) { //sort string ascending
                    return -1;
                } else if (labelA > labelB) {
                    return 1
                } else {
                    return 0 //default return value (no sorting)
                }
            }
        });
        this.fileFilter();
      },
	    playSound(file) {
	    	if (this.currentFile) {
			    this.stopSound();
		    }
		    this.currentFile = file;
            this.audio = this.$refs.audioPlayer;
		    var playPromise = this.audio.play();

		    if (playPromise !== undefined) {
			    playPromise.then(_ => {
			    })
				    .catch(error => {

				    });
		    }
	    },
	    stopSound() {
		    this.currentFile = '';
		    for (let i=0; i < this.PageFiles.length; i++) {
		    	this.PageFiles[i]['samplePlaying'] = 'n';
		    }
            this.audio = this.$refs.audioPlayer;

		    var playPromise = this.audio.pause();

		    if (playPromise !== undefined) {
			    playPromise.then(_ => {
			    })
				    .catch(error => {

                    });
		    }
	    },
        bulkFileDownload () {
            var FileIDs = [];
            for (let i=0; i < this.PageFiles.length; i++)
            {
                if (this.PageFiles[i].selected) {
                    FileIDs.push(this.PageFiles[i].FileID);
                    this.PageFiles[i].downloading = 'y';
                }
            }

            axios.post('/files/bulkdownload', {FileIDs : FileIDs}
            )
                .then(response => {
                    if (response.data.result == 'success') {
                        const link = document.createElement('a');
                        link.href = response.data.FileURL;
                        var filename = response.data.FileURL.replace(/^.*[\\\/]/, '')
                        link.setAttribute('download', filename) //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        for (let i=0; i < this.PageFiles.length; i++)
                        {
                            if (this.PageFiles[i].selected) {
                                this.PageFiles[i].selected = '';
                                this.PageFiles[i].downloading = 'n';
                            }
                        }
                    } else {
                        this.$notify({
                            title: 'Error',
                            message: "Files cannot be Downloaded",
                            type: 'error',
                            duration: 2000,
                            showClose: false
                        });
                    }
                }).catch(response => {
            });
        },
	    forceFileDownload(row){
            for (let i=0; i < this.PageFiles.length; i++)
            {
                if (this.PageFiles[i].FileID == row.FileID) {
                    this.PageFiles[i].downloading = 'y';
                    break;
                }
            }
		    axios.post('/files/download', {FileID : row.FileID}
		    )
			    .then(response => {
					if (response.data.result == 'success') {
						const link = document.createElement('a');
						link.href = response.data.FileURL;
						var filename = response.data.FileURL.replace(/^.*[\\\/]/, '')
						link.setAttribute('download', filename) //or any other extension
						document.body.appendChild(link);
						link.click();
                        for (let i=0; i < this.PageFiles.length; i++)
                        {
                            if (this.PageFiles[i].FileID == row.FileID) {
                                this.PageFiles[i].downloading = 'n';
                                break;
                            }
                        }
					} else {
						this.$notify({
							title: 'Error',
							message: "File cannot be Downloaded",
							type: 'error',
							duration: 2000,
							showClose: false
						});
					}
			    }).catch(response => {
		    });
	    },
	    getOrganizations () {
		    var tables = ['Organizations'];
		    axios.post('/index/tableData', {'tables': tables },
		    )
			    .then(response => {
				    if (response.data.result == 'success') {
					    for (let value of tables) {
						    this[value] = response.data[value];
					    }
					    this.getInitialData();
				    }
			    }).catch(response => {
		    });
	    },
	    getInitialData () {
		    this.loading = true;
		    axios.post('/index/dashboard', {Archived : (this.isArchives ? 'y' : (this.isHistorical ? 'h' : (this.isFavorites ? 'f' : 'n'))), OrganizationIDs : this.OrganizationIDs}
		    )
			    .then(response => {
				    if (response.data.result == 'success') {
					    this.Files = (response.data.Files ? response.data.Files : []);
					    this.organization = response.data.organization;
					    this.latest = (response.data.latest ? response.data.latest : []);
					    this.fileFilter();
					    this.Genres = (response.data.Genres ? response.data.Genres : []);
					    this.Moods = (response.data.Moods ? response.data.Moods : []);
					    this.BPMs = (response.data.BPMs ? response.data.BPMs : []);
					    this.Lengths = (response.data.Lengths ? response.data.Lengths : []);
					    this.Formats = (response.data.Formats ? response.data.Formats : []);
				    }
				    this.loading = false;
			    }).catch(response => {
			    this.loading = false;;
		    });
	    },
        updateMetadata (row) {
            axios.post('/files/savemetadata', {file : row}
            )
                .then(response => {
                    if (response.data.result == 'success') {
                        this.currentStatus = STATUS_INITIAL;
                        if (response.data.FileMetadataID) {
                            row.FileMetadataID = response.data.FileMetadataID;
                        }
                    } else {
                        this.currentStatus = STATUS_FAILED;
                        this.displayPopup(response.data.message);
                    }
                }).catch(response => {
                    this.currentStatus = STATUS_FAILED;
                    this.displayPopup('We encountered an error saving your data');
            });
        },
        displayPopup (message) {
            this.$alert(message,  {
                type: 'error',
                confirmButtonText: 'OK',
            });
        }
    },
	mounted() {
		this.getOrganizations();
	},
}
</script>

<style>
	.dashboard div.el-table th {
		font-weight: 800;
	}
	.dashboard div.el-table .cell {
		word-break: normal;
	}
	#app.dashboard .el-collapse-item__header {
		font-size: 15px;
	}
	#app.dashboard .el-collapse-item__content {
		padding-bottom: 0;
	}
	#app.dashboard .el-table .cell {
		line-height: 17px;
	}
	#app.dashboard .el-table__fixed-footer-wrapper tbody td div.cell {
		font-size: 16px;
		font-weight: 800;
		color: #000;
	}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	a {
		color: #42b983;
	}
	.card {
		padding: 20px;
	}
	.card-body {
		padding-top: 0;
	}
	table {
		width: 100%;
	}
	#app .card-header {
		margin-left: -11px;
		margin-right: -11px;
	}
	.col-12 {
		padding-left: 0px;
		padding-right: 0px;
	}
	.el-select {
		width: 100%;
		max-width: 300px;
	}
	i.fas {
		font-size: 20px;
		cursor:pointer;
	}
	.search {
		width: 50%;
		margin-bottom: 5px;
	}
	.client-logo {
		max-width: 50%;
		max-height: 75px;
	}
    .Favorite {
        color: #999999;
        cursor: pointer;
    }
    .selectedFavorite {
        color: #E6A23C;
        cursor: pointer;
    }
    .downloadcheckbox {
        float:left;
        margin-right: 20px !important;
    }
    .downloadbutton {
        float:left;
    }
</style>
